@if (items$ | async; as items) { @if (items !== '{}') { @if (items?.explodedViewList?.length) {
<div class="exploded-view-wrapper">
  <span [innerHTML]="'explodedView.goToExplodedViewPage' | cxTranslate"></span>&nbsp; @for (evList of
  items?.explodedViewList; track evList) {
  <a
    [routerLink]="
      [
        './',
        {
          cxRoute: 'explodedView',
          params: { productCode: items?.code, name: items?.name, explodedViewId: evList.uid }
        }
      ] | cxUrl
    "
    >{{ businessType == 'fish' ? evList?.displayName : evList.uid }}</a
  >
  }
  <mat-icon class="material-icons-sharp light manual-arrow">keyboard_arrow_right</mat-icon>
</div>
} @if (items?.sizeChart) {
<div>
  <div class="size-chart-wrapper">
    <span [innerHTML]="'product.productSizeChart.label' | cxTranslate"></span>&nbsp;
    <app-generic-link [target]="'_blank'" [url]="items?.sizeChart?.media" [icon]="'manual'">{{
      items.code
    }}</app-generic-link>
  </div>
</div>
} } }
